const general_en = require("./general_en");
const general_ru = require("./general_ru");
const general_tr = require("./general_tr");

// Standart-pages
const privacy_en = require("./pages/privacy_en");
const privacy_ru = require("./pages/privacy_ru");
const privacy_tr = require("./pages/privacy_tr");
const presentation_app_en = require("./pages/presentation-app_en");
const presentation_app_ru = require("./pages/presentation-app_ru");
const presentation_app_tr = require("./pages/presentation-app_tr");

// Program-pages
const program_pages_en = require("./pages/program_pages_en");
const program_pages_ru = require("./pages/program_pages_ru");

// Site-pages (smartdev)
const homepage_ru = require("./pages/smartdev/homepage/homepage_ru");
const homepage_en = require("./pages/smartdev/homepage/homepage_en");
const homepage_tr = require("./pages/smartdev/homepage/homepage_tr");
const portal_ru = require("./pages/smartdev/portal/portal_ru");
const portal_en = require("./pages/smartdev/portal/portal_en");
const portal_tr = require("./pages/smartdev/portal/portal_tr");
const services_ru = require("./pages/smartdev/services/services_ru");
const services_en = require("./pages/smartdev/services/services_en");
const services_tr = require("./pages/smartdev/services/services_tr");
const media_ru = require("./pages/smartdev/media/media_ru");
const media_en = require("./pages/smartdev/media/media_en");
const media_tr = require("./pages/smartdev/media/media_tr");
const contact_ru = require("./pages/smartdev/contact/contact_ru");
const contact_en = require("./pages/smartdev/contact/contact_en");
const contact_tr = require("./pages/smartdev/contact/contact_tr");

let lng = null;

const buildHeader = (base) => {
  const nav = (base && base.navbar) ? base.navbar : {};
  const title = (base && base.common && base.common.title) ? base.common.title : ((base && base.p && base.p.prgtitle) ? base.p.prgtitle : "");
  return {
    title: title,
    navlinks: {
      title: nav.logoText || title || "",
      linkhome: nav.home || "",
      linkservices: nav.services || "",
      linksubservices: nav.linksubservices || [],
      linkcontacts: nav.contact || "",
      linknews: nav.contact || "",
      linkabout: nav.contact || ""
    }
  };
};

module.exports = {
  _: "Server-side dictionary",
  en: {
    lng: "en", ...general_en, ...presentation_app_en, ...program_pages_en, ...privacy_en,
    ...homepage_en, ...portal_en, ...services_en, ...media_en, ...contact_en,
    header: buildHeader(general_en)
  },
  ru: {
    lng: "ru", ...general_ru, ...presentation_app_ru, ...program_pages_ru, ...privacy_ru,
    ...homepage_ru, ...portal_ru, ...services_ru, ...media_ru, ...contact_ru,
    header: buildHeader(general_ru)
  },
  tr: {
    lng: "tr", ...general_tr, ...presentation_app_tr, ...program_pages_en, ...privacy_tr,
    ...homepage_tr, ...portal_tr, ...services_tr, ...media_tr, ...contact_tr,
    header: buildHeader(general_tr)
  },
  get: (req) => {
    const isClientSide = !(typeof process !== "undefined" && (process.release.name.search(/node|io.js/) !== -1));
    if (isClientSide) { return (document.title === general_ru.p.prgtitle ? "ru" : (document.title === general_tr.p.prgtitle ? "tr" : "en")) } // For Client-side
    if (req && req.session && req.session.lng) { return req.session.lng }
    return (lng || "en"); // For Server-side
  },
  set: (lngparam) => { lng = lngparam }
};
